module.exports = require("jquery");


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 12
// module chunks = 0